import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../shared/data.service";
import { ConfirmationService } from "primeng/api";
import { RiScheduleModifyComponent } from "./ri-schedule-modify/ri-schedule-modify.component";

@Component({
	selector: "caass-ri-job-schedule-table",
	templateUrl: "./ri-job-schedule-table.component.html",
	styleUrls: ["./ri-job-schedule-table.component.css"],
})
export class RiJobScheduleTableComponent implements OnInit, OnChanges {
	constructor(private dataService: DataService_ScheduledJobs, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadJobSchedule();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.loadJobSchedule();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedJob: any;

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	//Main
	SelectedJobSchedule: any;
	lstJobSchedule: any = [];

	//Filter lists
	lstRunMonDesc: any = [];
	lstRunTueDesc: any = [];
	lstRunWedDesc: any = [];
	lstRunThuDesc: any = [];
	lstRunFriDesc: any = [];
	lstRunSatDesc: any = [];
	lstRunSunDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		// { field: "RunTimeDesc", header: "Time" },
		{ field: "RunMonDesc", header: "Monday" },
		{ field: "RunTueDesc", header: "Tuesday" },
		{ field: "RunWedDesc", header: "Wednesday" },
		{ field: "RunThuDesc", header: "Thursday" },
		{ field: "RunFriDesc", header: "Friday" },
		{ field: "RunSatDesc", header: "Saturday" },
		{ field: "RunSunDesc", header: "Sunday" },
		// { field: "ActiveDesc", header: "Active" },
	];

	TableLoading: boolean = false;
	Processing: boolean = false;

	ToggleText: string = "Deactivate Schedule";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadJobSchedule() {
		this.onRowUnselect(null);

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			return;
		}

		this.TableLoading = true;

		var result = this.dataService.JobScheduleSelectList(this.SelectedJob.JobID);
		result.subscribe(
			(response) => {
				this.TableLoading = false;

				this.lstJobSchedule = response;

				//Load Data Filter Lists
				this.lstRunMonDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunMonDesc))).sort();
				this.lstRunTueDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunTueDesc))).sort();
				this.lstRunWedDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunWedDesc))).sort();
				this.lstRunThuDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunThuDesc))).sort();
				this.lstRunFriDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunFriDesc))).sort();
				this.lstRunSatDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunSatDesc))).sort();
				this.lstRunSunDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.RunSunDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstJobSchedule.map((item: any) => item.ActiveDesc))).sort();
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadJobSchedule();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(RiScheduleModifyComponent, {
			header: "Add Schedule",
			width: "fit-content",
			data: {
				EditMode: false,
				JobID: this.SelectedJob.JobID,
				JobDesc: this.SelectedJob.JobDesc,
				JobScheduleID: -1,
				Active: 1,
				RunTime: new Date(),
				RunMon: true,
				RunTue: true,
				RunWed: true,
				RunThu: true,
				RunFri: true,
				RunSat: false,
				RunSun: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadJobSchedule();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedJobSchedule == undefined || this.SelectedJobSchedule.JobScheduleID <= 0) {
			this.errorMessage = "Select a schedule to edit";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to edit this schedule";
			return;
		}

		var ref = this.dialogService.open(RiScheduleModifyComponent, {
			header: "Edit Schedule",
			width: "fit-content",
			data: {
				EditMode: true,
				JobID: this.SelectedJob.JobID,
				JobDesc: this.SelectedJob.JobDesc,
				JobScheduleID: this.SelectedJobSchedule.JobScheduleID,
				Active: this.SelectedJobSchedule.Active,
				RunTime: new Date(this.SelectedJobSchedule.RunTime),
				RunMon: this.SelectedJobSchedule.RunMon,
				RunTue: this.SelectedJobSchedule.RunTue,
				RunWed: this.SelectedJobSchedule.RunWed,
				RunThu: this.SelectedJobSchedule.RunThu,
				RunFri: this.SelectedJobSchedule.RunFri,
				RunSat: this.SelectedJobSchedule.RunSat,
				RunSun: this.SelectedJobSchedule.RunSun,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadJobSchedule();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedJobSchedule == undefined || this.SelectedJobSchedule.JobScheduleID <= 0) {
			this.errorMessage = "Select a schedule to deactivate";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to edit this schedule";
			return;
		}

		this.Processing = true;
		var result = this.dataService.JobScheduleToggle(this.SelectedJobSchedule.JobScheduleID, this.SelectedJobSchedule.Active == true ? false : true);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schedule was " + (this.SelectedJob.Active == true ? "deactivated" : "activated") + " successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadJobSchedule();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (this.SelectedJob.Active == true ? "deactivate" : "activate") + " the schedule: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}
	onDelete() {
		this.errorMessage = "";

		if (this.SelectedJobSchedule == undefined || this.SelectedJobSchedule.JobScheduleID <= 0) {
			this.errorMessage = "Select a schedule to delete";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to delete schedules for this job";
			return;
		}

		this.confirmationService.confirm({
			key: "reportinboxscheduleconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this schedule? The report will no longer be generated at this time.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;
		var result = this.dataService.JobScheduleDelete(this.SelectedJobSchedule.JobScheduleID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schedule was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadJobSchedule();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the schedule: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedJobSchedule = val.data;

		this.ToggleText = "Deactivate Schedule";
		if (this.SelectedJobSchedule.Active == false) {
			this.ToggleText = "Activate Schedule";
		}
	}
	onRowUnselect(val) {
		this.SelectedJobSchedule = null;

		this.ToggleText = "Deactivate Schedule";
	}
	onRowDblClick(JobSchedule) {
		this.SelectedJobSchedule = JobSchedule;
		this.onEdit();

		this.ToggleText = "Deactivate Schedule";
		if (this.SelectedJobSchedule.Active == false) {
			this.ToggleText = "Activate Schedule";
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
